/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Bold_Fox_RunInputs */

const en_keen_bold_fox_run = /** @type {(inputs: Keen_Bold_Fox_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Segment`)
};

const de_keen_bold_fox_run = /** @type {(inputs: Keen_Bold_Fox_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Segment hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add Segment" |
*
* @param {Keen_Bold_Fox_RunInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_bold_fox_run = /** @type {((inputs?: Keen_Bold_Fox_RunInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Bold_Fox_RunInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_bold_fox_run(inputs)
	return de_keen_bold_fox_run(inputs)
});